module.exports = __webpack_public_path__ + "img/3.ea13ef8d.jpg";